const cards = [
  {
    title: '国漫崛起：从模仿到自我突破',
    desc: '国产漫画经过多年发展，已经形成了独特的叙事风格和视觉语言，越来越多的优秀作品正在走向世界。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20painting%20style%20illustration%20with%20dramatic%20brush%20strokes%2C%20warm%20coral%20and%20black%20ink%20tones%2C%20modern%20minimalist%20composition%2C%20artistic%20abstract%20shapes%20suggesting%20mountains%20and%20clouds&width=600&height=400&seq=card-01&orientation=landscape',
    date: '2024-12-22',
    tag: '深度分析',
  },
  {
    title: '日漫经典IP的现代化改编之路',
    desc: '经典日漫IP在新时代如何保持生命力？从《海贼王》到《进击的巨人》，探讨改编策略的演变。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20modern%20illustration%20style%20with%20clean%20lines%20and%20warm%20amber%20accents%2C%20minimalist%20design%2C%20soft%20gradients%2C%20editorial%20composition%20with%20subtle%20geometric%20elements&width=600&height=400&seq=card-02&orientation=landscape',
    date: '2024-12-21',
    tag: '行业观察',
  },
  {
    title: '条漫时代：手机阅读如何改变漫画创作',
    desc: '随着移动端成为主要阅读设备，竖屏条漫正在重塑漫画的创作方式和叙事节奏。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20digital%20illustration%20of%20a%20smartphone%20with%20colorful%20vertical%20comic%20strips%2C%20warm%20peach%20tones%2C%20clean%20minimalist%20aesthetic%2C%20soft%20lighting&width=600&height=400&seq=card-03&orientation=landscape',
    date: '2024-12-19',
    tag: '趋势解读',
  },
  {
    title: '漫画与动画的联动效应有多强',
    desc: '从《鬼灭之刃》到《间谍过家家》，动画化如何引爆原作漫画的阅读量？数据告诉你答案。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20illustration%20showing%20the%20connection%20between%20comic%20book%20and%20animation%20screens%2C%20warm%20coral%20and%20gold%20palette%2C%20modern%20editorial%20style%2C%20clean%20composition&width=600&height=400&seq=card-04&orientation=landscape',
    date: '2024-12-17',
    tag: '数据报告',
  },
  {
    title: '新人漫画家如何从零开始创作',
    desc: '从故事构思到分镜绘制，从业余爱好者到职业漫画家，每一步都需要积累和坚持。',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20a%20drawing%20desk%20with%20sketchbook%20and%20art%20supplies%2C%20warm%20inviting%20atmosphere%2C%20creative%20workspace%2C%20soft%20lighting%20from%20window&width=600&height=400&seq=card-05&orientation=landscape',
    date: '2024-12-14',
    tag: '创作指南',
  },
  {
    title: '漫画阅读器的技术进化史',
    desc: '从纸质翻页到数字下拉，漫画阅读方式经历了怎样的技术迭代？未来又会有哪些新可能？',
    img: 'https://readdy.ai/api/search-image?query=Clean%20modern%20illustration%20of%20digital%20reading%20devices%20evolution%2C%20warm%20minimalist%20style%2C%20soft%20amber%20and%20cream%20colors%2C%20tech%20lifestyle%20aesthetic&width=600&height=400&seq=card-06&orientation=landscape',
    date: '2024-12-12',
    tag: '技术科普',
  },
  {
    title: '漫画中的传统文化元素盘点',
    desc: '从服饰建筑到神话传说，传统文化正在成为国漫创作的富矿，让世界看到东方美学的魅力。',
    img: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20cultural%20elements%20in%20modern%20illustration%20style%2C%20warm%20coral%20and%20gold%20accents%2C%20elegant%20composition%20with%20architectural%20motifs%2C%20artistic%20editorial%20quality&width=600&height=400&seq=card-07&orientation=landscape',
    date: '2024-12-09',
    tag: '文化观察',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精彩推荐</h2>
          <p className="text-sm text-foreground-500">精选深度好文，发现漫画世界的无限可能</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.slice(0, 7).map((card, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:scale-[1.02] transition-transform ${
                idx === 6 ? 'sm:col-span-2 lg:col-span-3 xl:col-span-4 max-w-md mx-auto' : ''
              }`}
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 mb-2 line-clamp-2">{card.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 mb-3">{card.desc}</p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-calendar-line"></i>
                  <span>{card.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}